import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { Gear, Logout } from '../shared/components/Icons';

export default function LeanAppShell() {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem('sqetrack_token');
    window.location.href = '/login';
  };

  return (
    <div className="app">
      <header className="header">
        <div className="header-title">
          <svg viewBox="0 0 32 32" width="26" height="26" aria-hidden="true">
            <polygon points="3,27 12,27 17,15 8,15" fill="rgba(255,255,255,0.3)"/>
            <polygon points="10,23 19,23 24,11 15,11" fill="rgba(255,255,255,0.65)"/>
            <polygon points="17,19 26,19 31,7 22,7" fill="rgba(255,255,255,0.95)"/>
          </svg>
          <span className="header-logo-text">
            <span className="header-logo-sqe">SQE</span><span className="header-logo-track">Track</span>
          </span>
        </div>
        <nav className="header-nav">
          <NavLink
            to="/drills-app/practice"
            className={({ isActive }) => `nav-btn${isActive ? ' active' : ''}`}
          >
            Practice
          </NavLink>
          <NavLink
            to="/drills-app/performance"
            className={({ isActive }) => `nav-btn${isActive ? ' active' : ''}`}
          >
            Performance
          </NavLink>
        </nav>
        <div className="header-actions">
          <button className="icon-btn" onClick={() => navigate('/drills-app/profile')} title="Settings">
            <Gear size={15} />
          </button>
          <button className="icon-btn" onClick={logout} title="Log out">
            <Logout size={15} />
          </button>
        </div>
      </header>
      <main className="main lean-main">
        <Outlet />
      </main>
    </div>
  );
}
